module.exports = __webpack_public_path__ + "img/id-card-dont.48ab9290.png";